import { render } from "./DonateModal.vue?vue&type=template&id=3ffe5590&scoped=true&ts=true"
import script from "./DonateModal.vue?vue&type=script&lang=ts"
export * from "./DonateModal.vue?vue&type=script&lang=ts"

import "./DonateModal.vue?vue&type=style&index=0&id=3ffe5590&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffe5590"]])

export default __exports__